/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */

import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import { Navigate } from "react-router-dom";
import * as yup from "yup";
import { Formik, FormikProps, Form, Field, ErrorMessage } from "formik";
import { FormikErrorMessage } from "../components/formik-error-message";
import { WebLayout } from "../components/web-layout";
import { LoadingContainer } from "../components/loading-container";
import { API } from "../../utils/AxiosInstance";
import { create } from "../../actions/signup";

export interface Props {
    match: any;
    location: any;
    onSubmit: (
        email: string,
        password: string,
        partnerID: string,
        programID: string
    ) => any;
}

interface State {
    emailDisabled: boolean;
    email: string;
    password: string;
    confirm_password: string;
}

export function Screen({ match, location, onSubmit }: Props) {
    const [partnerID] = useState(match.params.partnerID);
    const [programID] = useState(match.params.programID);
    const [fetching, setFetching] = useState(false);
    const [redirect, setRedirect] = useState(false);
    const [email, setEmail] = useState("");
    const [redirectUrl, setRedirectUrl] = useState("");
    const [errors, setErrors] = useState<string | undefined>(undefined);
    const { search } = location;
    const lookupKey = new URLSearchParams(search as string).get("lookupKey");

    useEffect(() => {
        async function fetchAPI() {
            try {
                setFetching(true);
                const response = await API.get(
                    `/signup?lookup_key=${lookupKey}&partner_id=${partnerID}`
                );
                if (response.data.redirect) {
                    setRedirectUrl("/registered");
                    setRedirect(true);
                } else if (response.data.firstTimeUser) {
                    setRedirectUrl("");
                    setRedirect(true);
                } else if (response.data.errors) {
                    setErrors(response.data.errors as string);
                } else {
                    setEmail(response.data.user_data as string);
                }
                setFetching(false);
            } catch {
                setFetching(false);
            }
        }
        if (partnerID && programID) {
            void fetchAPI();
        }
    }, [lookupKey, partnerID, programID]);

    const schema = yup.object().shape({
        email: yup.string().email().required("Email is required"),
        password: yup
            .string()
            .min(8, "has to be equal or longer than 8 characters!")
            .required("password is required"),
        confirm_password: yup
            .string()
            .test(
                "match",
                "password do not match",
                function test(confirm_password) {
                    return confirm_password === this.parent.password;
                }
            )
            .required("Confirm password is required"),
    });

    const formikInitialValues: State = {
        email,
        password: "",
        confirm_password: "",
        emailDisabled: true,
    };

    const onSave = async (values: State, actions: any) => {
        try {
            await onSubmit(
                values.email,
                values.password,
                partnerID as string,
                programID as string
            );
            actions.setSubmitting(false);
        } catch (error: any) {
            actions.setSubmitting(false);
            if (error.data && error.data.errors) {
                actions.setErrors(error.data.errors);
            } else {
                toast.error((error as Error)?.message || "An error occurred");
            }
        }
    };

    if (fetching) {
        return <LoadingContainer />;
    }
    return (
        <WebLayout>
            {redirect && <Navigate to={redirectUrl} replace />}
            <Formik
                initialValues={formikInitialValues}
                onSubmit={onSave}
                validationSchema={schema}
                render={(formikProps: FormikProps<State>) => (
                    <Form
                        placeholder={undefined}
                        onPointerEnterCapture={undefined}
                        onPointerLeaveCapture={undefined}
                    >
                        <div className="pb-4">
                            <Field
                                type="email"
                                name="email"
                                placeholder="Email"
                                className="form-control"
                                disabled={formikProps.values.emailDisabled}
                                value={formikProps.values.email}
                            />
                            <ErrorMessage
                                name="email"
                                component={FormikErrorMessage}
                            />
                        </div>
                        <div className="pb-4">
                            <Field
                                type="password"
                                name="password"
                                placeholder="Create Your Password"
                                className="form-control"
                            />
                            <i className="text-xs">
                                Must contain a letter, a number and a symbol. It
                                must be at least 8 characters long.
                            </i>
                            <ErrorMessage
                                name="password"
                                component={FormikErrorMessage}
                            />
                        </div>
                        <div className="pb-4">
                            <Field
                                type="password"
                                name="confirm_password"
                                placeholder="Enter Your Password Again"
                                className="form-control"
                            />
                            <ErrorMessage
                                name="confirm_password"
                                component={FormikErrorMessage}
                            />
                        </div>
                        <button
                            type="submit"
                            className="btn btn-success form-control"
                            disabled={formikProps.isSubmitting}
                        >
                            REGISTER NOW!
                        </button>
                    </Form>
                )}
            />
            {errors ? <span className="color-red">{errors}</span> : null}
        </WebLayout>
    );
}

export const SignUp = connect(() => {}, {
    onSubmit: create,
})(Screen);
